module.exports = __webpack_public_path__ + "img/garden_thumb.ec8c8914.jpg";